import { render, staticRenderFns } from "./FilterCategory.vue?vue&type=template&id=24d373d0&scoped=true&"
import script from "./FilterCategory.vue?vue&type=script&lang=js&"
export * from "./FilterCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d373d0",
  null
  
)

export default component.exports